import Seo from "@/components/Seo";
import { useState } from "react";
import { WelcomeCodeCard } from "@/components/store/WelcomeCodeCard";
import Navbar from "@/components/store/Navbar";
import Hero from "@/components/store/Hero";
import Marquee from "@/components/store/Marquee";
import Catalog from "@/components/store/Catalog";
import Manifesto from "@/components/store/Manifesto";
import HeatPress from "@/components/store/HeatPress";
import Footer from "@/components/store/Footer";
import OrderDrawer from "@/components/store/OrderDrawer";
import CustomerGate from "@/components/store/CustomerGate";
import OfferPopup from "@/components/store/OfferPopup";
import MyOrders from "@/components/store/MyOrders";
import { useCustomer } from "@/context/CustomerContext";
import { useLenis } from "@/hooks/useLenis";
import { BRAND_SHORT } from "@/config";

export default function Storefront() {
  useLenis();
  const { customer } = useCustomer();
  const [welcomeCode, setWelcomeCode] = useState(() => localStorage.getItem("vs_welcome_code") || "");
  if (!customer) return <CustomerGate />;
  return (
    <div data-testid="storefront-page">
      <Seo
        title="Varsha Sublimation — Sublimation Blanks, Heat Press Machines & Gift Raw Material"
        siteName={BRAND_SHORT}
        description="Manufacturer & importer since 2010: heat press machines, sublimation mugs, STH t-shirts, MDF frames, clocks, lamps and printing accessories at factory-direct INR prices. Order on WhatsApp."
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Store",
          name: BRAND_SHORT,
          description: "Sublimation products manufacturer and importer: blanks, machines and accessories with WhatsApp ordering.",
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Catalog />
        <Manifesto />
        <HeatPress />
      </main>
      <Footer />
      <OrderDrawer />
      <MyOrders />
      {!welcomeCode && <OfferPopup />}
      <WelcomeCodeCard code={welcomeCode} onClose={() => { localStorage.removeItem("vs_welcome_code"); setWelcomeCode(""); }} />
    </div>
  );
}
